import { useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import { SelectedDateRange } from 'src/components/molecules/SelectedDateRange';
import { useFilterContext } from 'src/contexts/FilterContext';

export const SelectedTimeRange: React.FC = () => {
  const { timeRange } = useFilterContext();

  // const fontActiveColor = useColorModeValue(
  //   'text.light.active',
  //   'text.dark.active',
  // );

  const fontActiveColor = useColorModeValue(
    'text.darkBlue.900',
    'text.dark.highContrast',
  );

  return (
    <SelectedDateRange
      bold={true}
      start={timeRange.start}
      end={timeRange.end}
      fontActiveColor={fontActiveColor}
    />
  );
};
